<ui-page [testHook]="testHooks.Page">
	<router-outlet class="hidden-router"></router-outlet>
</ui-page>
